import React from "react";

export const TickForToast = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clipPath="url(#clip0_1296_11629)">
    <path d="M6.25033 10.0003L8.75033 12.5003L13.7503 7.50033M18.3337 10.0003C18.3337 14.6027 14.6027 18.3337 10.0003 18.3337C5.39795 18.3337 1.66699 14.6027 1.66699 10.0003C1.66699 5.39795 5.39795 1.66699 10.0003 1.66699C14.6027 1.66699 18.3337 5.39795 18.3337 10.0003Z" stroke="#00775E" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_1296_11629">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>
  );
};
